import {
  getAlertsFromList,
  getAlerts,
} from '@/services/api/internal/eDispatch/alerts.api';

export const ALERTS_TYPES = [
  {
    desc: 'alerte_chauffage',
    plan: 'alerte_chauffage_plan',
    date: 'alerte_chauff_datetime',
  },
  {
    desc: 'alerte_ecs_chauffage',
    plan: 'alerte_ecs_chauffage_plan',
    date: 'alerte_ecs_chauff_datetime',
  },
  {
    desc: 'alerte_legio',
    plan: 'alerte_legio_plan',
    date: 'alerte_legio_datetime',
  },
];

export const ALL_ALERTS_TYPES = [
  {
    desc: 'alerte_legio',
    plan: 'alerte_legio_plan',
    date: 'alerte_legio_datetime',
  },
  {
    desc: 'alerte_chauffage',
    plan: 'alerte_chauffage_plan',
    date: 'alerte_chauff_datetime',
  },
  {
    desc: 'alerte_ecs_chauffage',
    plan: 'alerte_ecs_chauffage_plan',
    date: 'alerte_ecs_chauff_datetime',
  },
  {
    desc: 'alerte_conso_pct',
    plan: 'alerte_conso_pct_plan',
    date: 'alerte_conso_pct_datetime',
  },
  {
    desc: 'alerte_consommation',
    plan: 'alerte_consommation_plan',
    date: 'alerte_conso_datetime',
  },
  {
    desc: 'alerte_conso_total',
    plan: 'alerte_conso_total_plan',
    date: 'alerte_conso_total_datetime',
  },
  {
    desc: 'alerte_ecs',
    plan: 'alerte_ecs_plan',
    date: 'alerte_ecs_datetime',
  },
];

export function treatAlertsResponse(alertsList) {
  return alertsList.map((alert) => {
    const anyAlert = ALERTS_TYPES.some((item) => alert[item.desc]);
    const anyUntreated = ALERTS_TYPES.some(
      (item) => alert[item.desc] && !alert[item.plan]
    );
    return { ...alert, anyAlert, anyUntreated };
  });
}

export function getAlertsInfos(items) {
  const idList = items.map((item) => item.property_id);
  return getAlertsFromList(idList).then((alertsList) =>
    treatAlertsResponse(alertsList)
  );
}

export const serviceAPI = {
  async getCurrent(id) {
    return getAlerts(id).then((items) => items[0]);
  },
};
